import { lazy } from 'react';

export const PlayerCancelLossLimitForm = lazy(
  () => import('./PlayerCancelLossLimitForm'),
);
